"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearMonthForm = void 0;
const react_1 = __importDefault(require("react"));
const dateTime_1 = require("../../../utils/dateTime");
require("./index.scss");
const className = 'DayPicker-Caption-year-month';
const YearMonthForm = (props) => {
    const { date, localeUtils, onChange, restrictions, } = props;
    const { pastYearsCount = dateTime_1.defaultPastYearsCount, nextYearsCount = dateTime_1.defaultNextYearsCount, } = restrictions || {};
    const selectedYear = date.getFullYear();
    const selectedMonth = date.getMonth();
    const currentYear = new Date().getFullYear();
    const fromMonth = new Date(Math.min(currentYear - pastYearsCount, selectedYear), 0);
    const toCurrentYear = currentYear + nextYearsCount;
    const toMonth = new Date(Math.max(toCurrentYear, selectedYear), 11);
    const months = localeUtils.getMonths();
    const years = [];
    for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
        years.unshift(i);
    }
    const handleChange = (event) => {
        const { year, month } = (event.target.form || {});
        onChange(new Date(year.value, month.value));
    };
    return (react_1.default.createElement("form", { className: className },
        react_1.default.createElement("div", { className: `${className}__select` },
            react_1.default.createElement("select", { className: `${className}__month`, name: 'month', onChange: handleChange, value: selectedMonth }, months.map((month, i) => (react_1.default.createElement("option", { key: month, value: i }, month)))),
            react_1.default.createElement("i", null)),
        react_1.default.createElement("div", { className: `${className}__select` },
            react_1.default.createElement("select", { className: `${className}__year`, name: 'year', onChange: handleChange, value: selectedYear }, years.map(year => (react_1.default.createElement("option", { key: year, value: year }, year)))),
            react_1.default.createElement("i", null))));
};
exports.YearMonthForm = YearMonthForm;
//# sourceMappingURL=index.js.map